import paper from 'paper';

import { Annotation } from '@paragon/contract-library';

import { UserData } from '../../store/users';
import { AnnotationVisibilitySettings } from '../../store/view';
import { ItemEventHandlers, registerItemEvents } from './paperItemEvents';
import { AnnotationWithSelectionData, PageImageInfo, renderAnnotation } from './paperItemTranslator';

function compareAnnotationsByZIndex(a: Annotation, b: Annotation) {
  return a.zIndex - b.zIndex;
}

export function renderAnnotationsToPaperJs(
  annotations: readonly AnnotationWithSelectionData[],
  pageImageInfo: PageImageInfo,
  userData: UserData,
  currentUserEmail: string,
  userAnnotationsVisible: AnnotationVisibilitySettings,
  systemAnnotationsEditable: boolean,
  eventHandlers: ItemEventHandlers,
  textAnnotationBeingEditedInlineGuid: string | null,
) {
  if (paper.project != null && paper.project.activeLayer != null) {
    // Remove all children except for the first one, which is the page image
    paper.project.activeLayer.removeChildren(1);

    let visibleAnnotations = annotations;
    if (textAnnotationBeingEditedInlineGuid !== null) {
      // Do not render the annotation for the text being edited inline; it is displayed in a text area (see
      // `EditTextAnnotationInline`)
      visibleAnnotations = visibleAnnotations.filter(
        (annotation) => annotation.guid !== textAnnotationBeingEditedInlineGuid,
      );
    }
    if (userAnnotationsVisible !== 'all') {
      visibleAnnotations = annotations.filter(
        (annotation) =>
          annotation.category === 'system' ||
          annotation.creatorEmail == null ||
          userAnnotationsVisible.includes(annotation.creatorEmail),
      );
    }

    const annotationRenderer = (annotation: AnnotationWithSelectionData) =>
      renderAnnotation(annotation, userData, currentUserEmail, systemAnnotationsEditable, pageImageInfo);

    const renderedPaperItems = visibleAnnotations.toSorted(compareAnnotationsByZIndex).map(annotationRenderer);
    const itemsToRegister = renderedPaperItems.filter((item) => item.shouldBeRegisteredForEvents);
    registerItemEvents(itemsToRegister, eventHandlers, pageImageInfo);

    paper.view.draw();
  }
}

export function clearActiveLayerPaperJs() {
  if (paper.project != null && paper.project.activeLayer != null) {
    paper.project.activeLayer.removeChildren();
    paper.view.draw();
  }
}
